import { FC } from "react";

import {
    InsightsTeam,
    InsightsIndividual,
} from "store/api/investorCompany/interfaces";
import InsightStatus from "../InsightStatus";
import { GaugeChart } from "components/ui/GaugeChart";
import Title from "routes/company/components/Modal/Title";
import IndividualScores from "routes/company/components/IndividualScores";
import InsightDescription from "routes/company/components/Modal/InsightDescription";

type Props = {
    tooltip: string;
    teamData: InsightsTeam;
    individualData: InsightsIndividual;
};

const TeamCompositionModal: FC<Props> = ({
    tooltip,
    individualData,
    teamData: { td_team_composition },
}) => {
    const tdTeamCompositionValue = (td_team_composition?.value as number) ?? 0;

    return (
        <div className="flex flex-col gap-4">
            <Title tooltip={tooltip}>Team composition</Title>

            <div className="flex justify-center">
                <GaugeChart value={tdTeamCompositionValue} />
            </div>

            <div>
                <InsightStatus value={tdTeamCompositionValue} />

                <InsightDescription>
                    {td_team_composition?.conclusion?.text ?? ""}
                </InsightDescription>
            </div>

            <IndividualScores
                individualData={individualData}
                teamMetricValue={tdTeamCompositionValue}
                metric="td_team_composition"
            />
        </div>
    );
};

export default TeamCompositionModal;
